export default class DalHelper {
  static getItemPath(dbConst: string, id: string) { return `${dbConst}/${id}`; }
}
